<template>
  <div class="flex-shrink-0">
    <div v-if="avatar" class="group relative rounded-full overflow-hidden">
      <img class="w-24 h-24" :src="`data:${avatar.mimeType};base64, ${avatar.base64}`" alt="Avatar">
      <div v-if="editable" class="absolute w-full h-full top-0 left-0 flex items-center justify-center bg-black bg-opacity-30 opacity-0 group-hover:opacity-100 cursor-pointer"
           @click="$refs.updateFile.click()">
        <PencilIcon class="text-white w-8 h-8"/>
      </div>
      <input ref="updateFile" class="hidden" type="file" name="file" accept="image/*"
             @change="update"/>
    </div>
    <div v-else class="group relative rounded-full overflow-hidden">
      <img class="w-24 h-24" src="@/assets/icons/user.png" alt="Avatar">
      <div v-if="editable" class="absolute w-full h-full top-0 left-0 flex items-center justify-center bg-black bg-opacity-30 opacity-0 group-hover:opacity-100 cursor-pointer"
           @click="$refs.storeFile.click()">
        <PencilIcon class="text-white w-8 h-8"/>
      </div>
      <input ref="storeFile" class="hidden" type="file" name="file" accept="image/*"
             @change="store"/>
    </div>
  </div>
</template>
<script>
import applicantApi from "../../../api/applicant/applicant";

export default {
  props: {
    id: Number,
    photo: Object,
    editable: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      avatar: this.photo
    }
  },
  methods: {
    store(event) {
      let formData = new FormData()
      formData.append('upfile', event.target.files[0])

      this.$emitter.emit('open-loader-modal')
      applicantApi.storeAvatar(this.id, formData)
          .then(res => {
            this.avatar = res
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
            this.$store.commit('setUserAvatar', res)
          })
          .catch(error => {
            this.$snotify.error(error)
          }).finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },
    update(event) {
      let formData = new FormData()
      formData.append('upfile', event.target.files[0])

      this.$emitter.emit('open-loader-modal')
      applicantApi.updateAvatar(this.id, this.avatar.id, formData)
          .then(res => {
            this.avatar = res
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
            this.$store.commit('setUserAvatar', res)
          })
          .catch(error => {
            this.$snotify.error(error)
          }).finally(() => {
        this.$emitter.emit('close-loader-modal')
      });
    }
  }
}
</script>